module.exports = __webpack_public_path__ + "img/heading_twitter.5058ac85.png";